import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/pl'
import 'dayjs/locale/ru'
import localeData from 'dayjs/plugin/localeData'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(localeData)
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(utc)

try {
  dayjs.locale(window.navigator.language || 'en')
} catch {
  try {
    const shortLocale = window.navigator.language.split('-')[0] // Get the language code (e.g., 'en' from 'en-US')

    dayjs.locale(shortLocale)
  } catch {
    dayjs.locale('en')
  }
}
